<template>
  <div v-if="visible" class="dialog-overlay" @click.self="close">
    <div class="dialog-content">
      <div class="dialog-header">
        <h2>Keyboard Shortcuts</h2>
        <button class="close-button" @click="close">
          <i class="fas fa-close"></i>
        </button>
      </div>
      <table>
        <tbody>
          <tr>
            <td colspan="2">
              <b>Global shortcuts (work anywhere on this page):</b>
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">$</td>
            <td>Open the Cash Position dialog.</td>
          </tr>
          <tr>
            <td class="ctrl-key">d</td>
            <td>
              Close email and the other tool panels, and open the document
              viewer.
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <b
                >When the pointer is over the ledger, you can use these keys:
              </b>
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">?</td>
            <td>
              show this [?] help dialog. You can also click the help button in
              the search bar area.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">e</td>
            <td>
              [E]dit the selected row in the ledger. You can also double-click
              the row to edit.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">p</td>
            <td>
              [P]rint the selected row in the ledger. You can also select the
              row and click the print button in the search bar area. If the
              check number is PRINT, it is replaced with the next check number
              and saved before the preview opens.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">s</td>
            <td>
              [S]how or hide splits in the ledger. You can also click the splits
              button in the search bar area.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">n</td>
            <td>
              Create a [N]ew ledger entry. You can also click the plus button in
              the search bar area.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">← →</td>
            <td>
              Use left and right arrow keys to switch between accounts in the
              "Select Account" dropdown.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">CTRL + ↑</td>
            <td>Scroll to the top of the ledger table.</td>
          </tr>
          <tr>
            <td class="ctrl-key">CTRL + ↓</td>
            <td>Scroll to the bottom of the ledger table.</td>
          </tr>
          <tr>
            <td class="ctrl-key">↑ ↓</td>
            <td>
              When a row is selected, use up and down arrow keys to navigate to
              the previous or next row in the table.
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <b
                >When a row is selected in the ledger, you can use these
                combination keys:
              </b>
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">CTRL + b</td>
            <td>
              Select a single row in Ledger to search by Id in [B]ank; the row
              must have a green checkmark in the matched ("M") column.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">CTRL + <u>V</u></td>
            <td>Select a single row in Ledger to [V]oid.</td>
          </tr>
          <tr>
            <td class="ctrl-key">Shift + L</td>
            <td>
              [L]ink the open document (document viewer) to the selected ledger
              row. Same as the link icon in the document viewer.
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <b
                >The following are modifiers that you can use in search
                inputs:</b
              >
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">:u</td>
            <td>
              find unmatched transactions in bank; or uncleared checks in ledger
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">:v</td>
            <td>find voided checks in ledger</td>
          </tr>
          <tr>
            <td class="ctrl-key">:n</td>
            <td>find transactions with notes in bank</td>
          </tr>
          <tr>
            <td class="ctrl-key">:a</td>
            <td>show only the selected account in ledger</td>
          </tr>
          <tr>
            <td class="ctrl-key">:f</td>
            <td>show only future dated transactions in the ledger</td>
          </tr>
          <tr>
            <td class="ctrl-key">:m, !m</td>
            <td>show only matched/unmatched transactions in the ledger</td>
          </tr>
          <tr>
            <td class="ctrl-key">:t</td>
            <td>show only today's transactions in the ledger</td>
          </tr>
          <tr>
            <td colspan="2">
              <b>To search for uncleared checks in ledger:</b>
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">Tab, then f</td>
            <td>
              After entering a check number in the search intput, press Tab,
              then 'f' to find this check number in the bank ledger. Press Esc
              to automatically select the search input box.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">Escape</td>
            <td>
              Press Escape to focus on the search input to enter the next check
              number. Press Escape again while in search to clear it.
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <b>To match bank transactions with ledger entries:</b>
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">f</td>
            <td>
              Highlight a transaction in the bank, then press 'f' to search for
              it in the ledger below. If you hover over the check number field,
              it will search by check number. Otherwise, it will use the amount.
            </td>
          </tr>
          <tr>
            <td class="ctrl-key">m</td>
            <td>
              If a match is found in the ledger, move your mouse there and press
              'm' to match it.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.dialog-content {
  background: #efefef;
  box-shadow: 9px 13px 7px 4px rgb(0 0 0 / 22%);
  padding: 20px;
  border-radius: 5px;
  width: 850px;
  max-width: 80%;
}
.dialog-content h2 {
  margin: 0;
  color: #fff;
  font-size: 1.5em;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding: 8px 15px;
  background: #333;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin-bottom: 10px;
}

.dialog-content ul {
  list-style-type: none;
  padding: 0;
}
.dialog-content ul li {
  margin-bottom: 10px;
}
.close-button {
  background-color: #a898b7;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 6px 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.close-button:hover {
  background-color: #9386a4;
}

.dialog-content table {
  font-size: 10pt;
  font-family: system-ui;
  width: 90%;
  margin-left: 23px;
}

.dialog-content tr {
  margin-left: 5px;
}
.dialog-content td {
  padding: 4px;
}
.dialog-content .ctrl-key {
  width: 80px;
  font-family: 'Courier New', Courier, monospace;
  font-weight: bold;
  vertical-align: top;
}

.action-row {
  margin-right: 15px;
  text-align: right;
}
</style>
